export const getCountryFlag = (countryCode) => `/static/img/flags/${countryCode?.toLowerCase()}.png`;
